import { MprcJoinComponents } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { KnowledgeUserMixPublicationSource } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { CardChannelLink } from "views/knowledge/components/card/behaviors/common/CardChannelLink";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { DefaultClassification } from "../common/DefaultClassification";

///
export const FeedStartupClassification = () => {
    const { pub } = useCardContext();
    const { t } = useTranslation("knowledge");

    const components: React.ReactNode[] = [];

    if (pub.interaction.reclassified)
        components.push(<MprcFeedTypography variant="classification" component="span" color="error">{t("Feed.Card.Common.ReclassifiedText")}</MprcFeedTypography>);
    else if (pub.publicationSource == KnowledgeUserMixPublicationSource.InHigh
        || pub.publicationSource == KnowledgeUserMixPublicationSource.RecommendedIA
        || pub.publicationSource == KnowledgeUserMixPublicationSource.DirectQuestion
        || pub.publicationSource == KnowledgeUserMixPublicationSource.QuestionIA)
        components.push(<MprcFeedTypography variant="classification">{pub.publicationSourceName}</MprcFeedTypography>);

    if (components.length > 0 && pub.channel?.name)
        components.push(<MprcFeedTypography variant="classification"><CardChannelLink /></MprcFeedTypography>);

    return components.length > 0
        ? <MprcFeedTypography variant="classification" noWrap component="div"><MprcJoinComponents separator="&bull;" components={components} /></MprcFeedTypography>
        : <DefaultClassification />;
};
